import api from './api';

export class ConfiguracaoPortalService {
  getConfiguracaoesPortal = (parametro) => {
    return api.get('ObterConfiguracoesPortal', {
      params: {
        parametro,
      },
    });
  };

  verificarManutencao = async () => {
    const response = await api.get('VerificarManutencao');
    return response.data;
  };

  VerificarPendenciasUsuario = async (matricula, token) => {
    const response = await api.get('VerificarPendenciasUsuario', {
      params: {
        matricula,
        token,
      },
    });
    return response.data[0];
  };

  // GerarPdfPrimeiraAssinaturaSign = async (matricula, token) => {
  //   const response = await api.post('GerarPdfPrimeiraAssinaturaSign', {
  //     matricula,
  //     token,
  //   });
  //   return response.data;
  // };

  GerarAceiteTermoConsentimento = async (matricula, token) => {
    const response = await api.post('RegistrarConfirmacaoTermoConsentimento', {
      matricula,
      token,
    });
    return response.data;
  };

  RegistrarConfirmacaoCadastroAtualizado = async (matricula, cpf, token) => {
    const response = await api.post('RegistrarConfirmacaoCadastroAtualizado', {
      matricula,
      cpf,
      token,
    });
    return response.data[0];
  };
}
